export function deadlinePayload(date, hardDeadline, now = Date.now()) {
  if (!date) {
    if (hardDeadline) throw new Error("Selecciona fecha y hora para el cierre automático.");
    return { hardDeadline: false };
  }
  const due = new Date(date);
  if (!Number.isFinite(due.getTime()) || due.getTime() <= now) throw new Error("La fecha y hora límite deben estar en el futuro.");
  return { dueAt: due.toISOString(), hardDeadline: !!hardDeadline };
}

export function deadlineTimestamp(assignment) {
  if (assignment?.dueAt) return Date.parse(assignment.dueAt);
  return assignment?.due ? Date.parse(assignment.due + "T23:59:59") : NaN;
}

export function deadlineExpired(assignment, now = Date.now()) {
  const timestamp = deadlineTimestamp(assignment);
  return Number.isFinite(timestamp) && now + (assignment?.clockOffset || 0) >= timestamp;
}

export function deadlineDate(assignment) {
  return assignment?.dueAt ? new Date(assignment.dueAt).toLocaleDateString("es-MX") : assignment?.due || "—";
}

export function deadlineHour(assignment) {
  return assignment?.dueAt ? new Date(assignment.dueAt).toLocaleTimeString("es-MX", { hour: "2-digit", minute: "2-digit", hourCycle: "h23" }) : "—";
}

export const localTimeZone = () => Intl.DateTimeFormat().resolvedOptions().timeZone;

export function timerPayload(enabled, minutes) {
  if (!enabled) return { timeLimitMinutes: null };
  if (!Number.isInteger(minutes) || minutes < 1 || minutes > 10080) throw new Error("La duración debe ser un número entero entre 1 y 10080 minutos.");
  return { timeLimitMinutes: minutes };
}

export function blockingTimestamp(assignment) {
  const candidates = [assignment?.deadlineAt, assignment?.timerExpiresAt, assignment?.hardDeadline ? assignment?.dueAt : null]
    .filter(Boolean).map(value => Date.parse(value)).filter(Number.isFinite);
  return candidates.length ? Math.min(...candidates) : NaN;
}

export function assignmentClosed(assignment, now = Date.now()) {
  const cutoff = blockingTimestamp(assignment);
  return Number.isFinite(cutoff) && now + (assignment?.clockOffset || 0) >= cutoff;
}

export function countdown(seconds) {
  const total = Math.max(0, Math.ceil(seconds));
  const hours = Math.floor(total / 3600);
  const minutes = Math.floor(total % 3600 / 60);
  return `${String(hours).padStart(2, "0")}:${String(minutes).padStart(2, "0")}:${String(total % 60).padStart(2, "0")}`;
}
